import { gql } from '@zenbusiness/application-commons-graphql';

// Define query get payments
export const GET_PAYMENTS_QUERY = gql`
  query payments($filter: BankingPaymentsFilter!, $page: OffsetPageInput!) {
    bankingPayments(filter: $filter, page: $page) {
      bankingPayments {
        id
      }
    }
  }
`;

export const GET_LIST_PAYMENTS_QUERY = gql`
  query paymentsList($filter: BankingPaymentsFilter!, $page: OffsetPageInput!) {
    bankingPayments(filter: $filter, page: $page) {
      bankingPayments {
        id
        type
        status
        direction
        summary
        amount {
          amount
          currency
          formattedAmount
        }
        reason
        createdAt
        counterpartyId
        fromAccount
        toAccount
        transactionId
        estimatedCompletionDate
        description
        counterpartyId
        # new attributes
        sameDay
        # to account fields
        to {
          accountHolder
          accountNumber
          accountNumberLast4
          routingNumber
        }
        # from account fields
        from {
          accountHolder
          accountNumber
          accountNumberLast4
          routingNumber
        }
      }
      pageInfo {
        page
        pageSize
        hasNextPage
        totalCount
      }
    }
  }
`;
